/** @jsx jsx */
import { jsx } from "theme-ui";
import Planets from "./space/Planets";
import AsteroidField from "./space/AsteroidField";
import Constellation from "./space/Constellation";
import SpaceText from "./space/SpaceText";

const SpaceTransition = ({
  offset,
  factor = 1.5,
}: {
  offset: number;
  factor?: number;
}) => (
  <div>
    <Planets offset={offset} factor={factor} />
    <AsteroidField offset={offset} factor={factor} />
    <Constellation offset={offset} factor={factor} />
    <SpaceText offset={offset} factor={factor} />
  </div>
);

export default SpaceTransition;
